import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import get from 'lodash.get';

import { BarHeader } from 'dibs-elements/exports/BarHeader';
import { ContemporaryLandingStyleRow } from './ContemporaryLandingStyleRow';

const ContemporaryLandingStyleModuleComponent = ({ contemporaryLandingRow, showCta }) => {
    if (!contemporaryLandingRow || !contemporaryLandingRow.items) {
        return null;
    }
    const styleRows = contemporaryLandingRow.items.filter(item => item.type === 'styleRow');

    return (
        <React.Fragment>
            <BarHeader title={get(contemporaryLandingRow, 'items[0].text')} />
            {styleRows.map((styleRow, index) => (
                <ContemporaryLandingStyleRow
                    key={`${styleRow.title}-${index}`}
                    items={get(styleRow, 'items')}
                    rowIndex={index}
                    showCta={showCta}
                />
            ))}
        </React.Fragment>
    );
};

ContemporaryLandingStyleModuleComponent.defaultProps = {
    showCta: false,
};

ContemporaryLandingStyleModuleComponent.propTypes = {
    showCta: PropTypes.bool.isRequired,
    contemporaryLandingRow: PropTypes.object,
};

export const ContemporaryLandingStyleModule = createFragmentContainer(
    ContemporaryLandingStyleModuleComponent,
    {
        contemporaryLandingRow: graphql`
            fragment ContemporaryLandingStyleModule_contemporaryLandingRow on ContemporaryLandingRow {
                ... on ContemporaryLandingRow {
                    items {
                        ... on ContemporaryLandingHeader {
                            text
                            type
                        }
                        ... on ContemporaryLandingRow {
                            items {
                                ... on ContemporaryLandingStyleRowItem {
                                    description
                                    imagePath
                                    title
                                    url
                                }
                            }
                            type
                        }
                    }
                }
            }
        `,
    }
);
